module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-start": "",
      "justify-center": "",
      "row": "",
      "date-range-selector": ""
    }
  }, [_c('v-flex', {
    staticClass: "item elevation-5"
  }, [_c('dash-date-picker', {
    attrs: {
      "range-control": _vm.dateValue.from,
      "label": "Date From",
      "full-date": _vm.dateValue,
      "identifier": "dateFrom"
    },
    on: {
      "date-picked": _vm.updateFromDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item elevation-5"
  }, [_c('dash-date-picker', {
    attrs: {
      "range-control": _vm.dateValue.to,
      "label": "Date To",
      "full-date": _vm.dateValue,
      "identifier": "dateTo"
    },
    on: {
      "date-picked": _vm.updateToDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item elevation-5 date-success"
  }, [_c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.updateDates
    }
  }, [_vm._v("Go")])], 1)], 1)
},staticRenderFns: []}